<div class="claim-information-wrapper">
    <div class="section-heading">Claim Information</div>
    <div>
        <app-claim-information-display [claimInformation]="informationStep.data"
                                       [attachments]="attachments"
                                       [directory]="directory"
                                       [requiredAttachments]="requiredAttachments"></app-claim-information-display>
    </div>
</div>
<div class="claim-material-position-table-wrapper">
    <app-material-position-table [material]="material"
                                 [showButtonAdd]="false"
                                 [showMaterialTitle]="false"
                                 [showSectionTitle]="true"
                                 [showContextMenu]="false"></app-material-position-table>
</div>